<template>
  <button
    class="stepper-control__btn--up"
    :disabled="disabled || null"
    @click="onClick"
  >
    <ChevronUp class="stepper-control__btn-icon--up" />
  </button>
</template>
<script>
import ChevronUp from '../../atoms/svg_icons/ChevronUp.vue'

export default {
  components: {
    ChevronUp
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  methods: {
    onClick() {
      this.$emit('click-stepper-control-btn-up')
    }
  }
}
</script>
<style lang="scss" scoped>
.stepper-control {
  &__btn--up {
    width: 36px;
    height: 36px;
    background-color: $black;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:disabled {
      cursor: default;
      background-color: $gray-2;
    }
  }

  &__btn-icon--up {
    fill: $white;
  }
}
</style>
